import { Component, Input } from '@angular/core';
@Component({
  selector: 'hivegpt-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss'],
})
export class ChatBotComponent {
  @Input() userId!: string;
  @Input() apiKey!: string;
  @Input() botName!: string;
  @Input() botId!: string;
  @Input() closeButtonColor!: string;
  @Input() gradientColors!: string[];
  @Input() greeting!: string;
  @Input() sendButtonColor!: string;
  @Input() useOpenAi!: boolean;
  @Input() showClose!: boolean;
  @Input() bgGradient!: string[];
  @Input() sendButtonTextColor!: string;
  @Input() fullView!: boolean;
  @Input() bgBubbleAi!: string;
  @Input() bgBubbleUser!: string;
  @Input() closeButtonbgColor!: string;
  @Input() messageTextColorAi!: string;
  @Input() messageTextColorUser!: string;
  @Input() dateTimeColor!: string;
  @Input() dateTextColor!: string;
  @Input() formFieldBgColor!: string;
  @Input() formFieldTextColor!: string;
  @Input() thumbsUpMessage!: string;
  @Input() thumbsDownMessages!: string[];
  @Input() timezone!: string;
  @Input() eventName!: string;
  @Input() credentials!: [];
  @Input() unknownResponses!: [];
  @Input() rules!: string;
  @Input() eventId!: string;
  visible = false;

  toggle() {
    this.visible = !this.visible;
  }
}
